import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import { path } from 'ramda'
import LinearProgress from '@material-ui/core/LinearProgress'
import ContentUnavailable from '@components/content-unavailable'
import Error from '@components/error'
import { getProfileSchema } from '@schema/coach-profile'
import CoachPage from './coach-page'

const COACH_QUERY = gql`
  query CoachProfiles($customSlug: String) {
    CoachProfiles(customSlug: $customSlug) {
      message,
      profiles {
        ${getProfileSchema}
      }
    }
  }
`

export { COACH_QUERY }

export default function CoachPageWithData(props) {
  const {
    query, ssrData, section, initialOfferingsByPersona, coachProfileUxEnabled,
  } = props
  const { slug } = query
  const layoutProps = {
    section, initialOfferingsByPersona, coachProfileUxEnabled,
  }

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    if (!ssrData) return <Error statusCode={404} />
    if (!ssrData.coach?.pgaCoachEligible) return <ContentUnavailable />
    return <CoachPage coach={ssrData} {...layoutProps} />
  }

  // Fallback to client-side fetching
  return (
    <Query query={COACH_QUERY} variables={{ customSlug: slug }} context={{ clientName: 'coach-tools' }}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const coachProfile = path(['CoachProfiles', 'profiles', 0], data)

        if (!coachProfile) return <Error statusCode={404} />
        if (!coachProfile.coach.pgaCoachEligible) return <ContentUnavailable />

        return <CoachPage coach={coachProfile} {...layoutProps} />
      }}
    </Query>
  )
}

CoachPageWithData.propTypes = {
  query: PropTypes.shape({
    slug: PropTypes.string,
  }),
  ssrData: PropTypes.object,
  /** Active section slug (`about`, `contact`, persona id). Defaults to About. */
  section: PropTypes.string,
  /**
   * Algolia offering map prefetched on the server for the About shop so the
   * client doesn't refetch + show a skeleton for already-known data.
   */
  initialOfferingsByPersona: PropTypes.objectOf(PropTypes.array),
  coachProfileUxEnabled: PropTypes.bool,
}
